module.exports = __webpack_public_path__ + "static/assets/ef9ad7d985162ed527aca819ad691267.png";